import { createRoot } from 'react-dom/client'
import App from './App'
import ErrorPrevent from './ErrorPrevent'

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <ErrorPrevent>
    <App />
  </ErrorPrevent>
)
